// extracted by mini-css-extract-plugin
export default {"Container":"AddBook_Container__W0mi4","Created":"AddBook_Created__9vOhj"};